<!-- Payment summary ---->
<div class="page-container">
  <div class="relative page-edge-cut">
    <div class="form-card">
      <form [formGroup]="form">
        @if (!isVenueBookingService) {
          <h1 class="section-heading">{{ "PAY.SUMMARY" | translate }}</h1>
        }

        @if (paymentLoader) {
          <app-skeleton-loader></app-skeleton-loader>
        }

        @if (!paymentLoader) {
          <!-- Selected room data -->
          @if (isVenueBookingService && venuePaymentSummary) {
            <div class="venue-payment-layout mb-8">
              <h1 class="section-heading">
                {{ "PAY.VENUE_BOOKING_AND_PAYMENT_SUMMARY" | translate }}
              </h1>
              @if (venueSummaryCard && venueSummaryCard.roomName) {
                <div class="bg-gray-100 p-4 lg:p-6 mb-10">
                  <div class="flex flex-col lg:flex-row gap-6">
                    @if (hasVenueSummaryCard && venueSummaryCard.imageUrl) {
                      <img
                        [src]="venueSummaryCard.imageUrl"
                        [alt]="venueSummaryCard.roomName || 'Venue room'"
                        class="w-full lg:w-52 h-32 object-fill"
                      />
                    } @else {
                      <div class="w-full lg:w-52 h-32 bg-gray-200"></div>
                    }
                    <div class="flex-1 space-y-1">
                      <h3
                        class="text-lg font-semibold text-dc-navy underline underline-offset-4"
                      >
                        {{ venueSummaryCard.roomName || "-" }}
                      </h3>
                      <div class="mt-2">
                        <p class="text-sm !text-dc-navy">
                          {{
                            "VENUE.AMENITIES"
                              | translate
                                : { amenities: venueSummaryCard.amenities }
                          }}
                        </p>
                        <ul
                          class="text-sm space-y-0.5 mt-2 text-dc-navy font-semibold"
                        >
                          <li>
                            {{ venueSummaryCard.dateText | date: "MMMM dd" }}
                          </li>
                          <li>{{ "VENUE.BOOKING_TIME" | translate }}</li>
                        </ul>
                      </div>
                    </div>
                    <div>
                      <ul class="text-sm space-y-0.5 mt-2 text-dc-navy">
                        <li class="mb-3">
                          <div class="dc-arrow-blue">
                            <span class="font-semibold">{{
                              venueSummaryCard.seats
                            }}</span>
                            {{ "VENUE.SEATS" | translate }}
                          </div>
                        </li>
                        <li class="mb-4">
                          <div class="dc-arrow-red">
                            {{ "VENUE.ACCESSIBLE" | translate }}
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              }
            </div>
          }
          <!-- END -->

          <table class="dc-table mb-8 m-2">
            <tbody>
              @if (isVenueBookingService && venuePaymentSummary) {
                <tr>
                  <td colspan="2" class="pt-2 pb-1" style="padding: 0">
                    <h1 class="section-heading">
                      {{ "PAY.VENUE_PAYMENT_DETAILS" | translate }}
                    </h1>
                  </td>
                </tr>
                @for (
                  item of venuePaymentSummary.paymentDetails;
                  track $index
                ) {
                  <tr [class.border-t]="item.label === 'Total Fees'">
                    <td class="td_label w-[50%]">{{ item.label }}</td>
                    <td class="td_value">
                      <span class="currency-amount">
                        <span class="currency-icon currency-icon-aed"></span>
                        {{ item.amount | number: "1.0-2" }}
                      </span>
                    </td>
                  </tr>
                }
                <tr>
                  <td colspan="2" class="" style="padding: 32px 0 0px 0">
                    <h1 class="section-heading">
                      {{ "PAY.VENUE_PAYABLE_AMOUNT" | translate }}
                    </h1>
                  </td>
                </tr>
                @for (item of venuePaymentSummary.payableAmount; track $index) {
                  <tr [class.border-t]="item.label === 'Total Fees'">
                    <td class="td_label w-[50%]">{{ item.label }}</td>
                    <td class="td_value">
                      <span class="currency-amount">
                        <span class="currency-icon currency-icon-aed"></span>
                        {{ item.amount | number: "1.0-2" }}
                      </span>
                    </td>
                  </tr>
                }
              } @else {
                @for (payment of paymentList; track $index) {
                  @if (isMultiplePayment) {
                    <tr>
                      <td class="w-[50%]">{{ "PAY.SR_NUMBER" | translate }}</td>
                      <td>
                        <b>{{ payment["SR Number"] }}</b>
                      </td>
                    </tr>
                  }
                  <!--DC FS Charge list  -->
                  @for (row of payment["DC FS Charge"]; track $index) {
                    <tr>
                      <td class="td_label w-[50%]">
                        {{ row["Product Name"] }}
                      </td>
                      <td class="td_value">
                        <span class="currency-amount">
                          <span class="currency-icon currency-icon-aed"></span>
                          {{ row["Amount"] | number: "1.2-2" }}
                        </span>
                      </td>
                    </tr>
                  }
                }
                <tr class="border-t font-semibold">
                  <td class="td_label w-[50%]">
                    {{ "PAY.TOTAL" | translate }}
                  </td>
                  <td class="td_value">
                    <span class="currency-amount">
                      <span class="currency-icon currency-icon-aed"></span>
                      {{ grandTotal | number: "1.2-2" }}
                    </span>
                  </td>
                </tr>
              }
            </tbody>
          </table>

          <!-- Pay-method selector ---->
          <h1 class="section-heading">{{ "PAY.HOW_PAY" | translate }}</h1>
          <div class="fields-container">
            <div class="field-control">
              <app-boolean
                [label]="'PAY.SELECT_PAYMENT_METHOD' | translate"
                [control]="form.get('payMethod')"
                [lovType]="lookupKey.DC_ONLINE_PAY_TYPE"
                [labelKey]="'Value'"
                [valueKey]="'Value'"
              ></app-boolean>
              <!-- [options]="[
                {
                  value: 'Noqodi Pay',
                  label: ('PAY.METHOD_NOQODI' | translate)
                },
                { value: 'DubaiPay', label: ('PAY.METHOD_DUBAI' | translate) }
              ]" -->
            </div>
          </div>
          <!-- Card-details block (visible only for card) -->
          @if (byCard) {
            <h1 class="section-heading mt-6">
              {{ "PAY.CARD_DETAILS" | translate }}
            </h1>
            <div class="fields-container">
              <div class="field-control">
                <app-text-field
                  [type]="'text'"
                  [label]="'PAY.CARD_NUMBER' | translate"
                  [control]="form.get('cardNumber')!"
                  [validationMessages]="{
                    cardNumber: 'VALIDATION_MSG.CARD' | translate,
                  }"
                ></app-text-field>
              </div>
              <div class="field-control">
                <label class="field-label mb-1">
                  {{ "PAY.EXPIRY" | translate }}
                </label>
                <div class="grid grid-cols-4 gap-4 mb-4">
                  <app-option-field
                    [control]="form.get('expMonth')!"
                    [options]="months"
                    [label]="'MONTH' | translate"
                  ></app-option-field>
                  <app-option-field
                    [control]="form.get('expYear')!"
                    [options]="years"
                    [label]="'YEAR' | translate"
                  ></app-option-field>
                </div>
              </div>
              <div class="field-control">
                <app-text-field
                  [label]="'PAY.CARD_NAME' | translate"
                  [control]="form.get('cardName')!"
                ></app-text-field>
              </div>
              <div class="field-control">
                <app-text-field
                  [type]="'password'"
                  [label]="'PAY.CVV' | translate"
                  [control]="form.get('cvv')!"
                  [otherInfo]="'PAY.CVV_HINT' | translate"
                  [validationMessages]="{
                    cvv: 'VALIDATION_MSG.CVV' | translate,
                  }"
                ></app-text-field>
              </div>
            </div>
          }
          @if (technicalErrorMsg) {
            <app-validation-message
              [type]="'error'"
              [content]="{
                title: 'VALIDATION_MSG.ERROR' | translate,
                message: 'TOAST_MESSAGES.TECHNICAL_ERROR' | translate,
              }"
              [showbutton]="false"
            ></app-validation-message>
          }

          @if (subServiceType == service.ISSUE_NEW_CARNET) {
            <app-validation-message
              [type]="'info'"
              [content]="{
                title: 'TOAST_MESSAGES.INFO' | translate,
                message: 'TOAST_MESSAGES.ATA_DEPOSIT_NOTE' | translate,
                sections: [
                  {
                    title: 'ATA_BANK_DETAILS.NOTE_TITLE' | translate,
                    items: [
                      'ATA_BANK_DETAILS.ACCOUNT_DETAILS' | translate,
                      'ATA_BANK_DETAILS.ACCOUNT_NAME' | translate,
                      'ATA_BANK_DETAILS.ACCOUNT_NO' | translate,
                      'ATA_BANK_DETAILS.IBAN' | translate,
                      'ATA_BANK_DETAILS.BANK_NAME' | translate,
                      'ATA_BANK_DETAILS.ADDRESS' | translate,
                      'ATA_BANK_DETAILS.SWIFT_CODE' | translate,
                    ],
                  },
                ],
              }"
              [showTypeIcon]="true"
              [showCloseIcon]="false"
              [showbutton]="false"
            ></app-validation-message>
          }
          @if (paymentList && paymentList.length > 0) {
            <div class="btn-section buttons-group">
              @if (hasZeroPayableAmount) {
                <app-validation-message
                  [type]="'info'"
                  [showCloseIcon]="false"
                  [content]="{
                    title: 'TOAST_MESSAGES.INFO' | translate,
                    message: 'PAY.ZERO_TOTAL_CONTACT_CARE' | translate
                  }"
                ></app-validation-message>
              } @else if (!redirectingToPayment) {
                <app-button
                  classesName="btn-edge-cut btn-width-auto"
                  [label]="'BUTTONS.PAY' | translate"
                  (onBtnClick)="pay()"
                ></app-button>
              }
              @if (redirectingToPayment) {
                <app-button
                  type="button"
                  classesName="btn-edge-cut btn-width-auto"
                  [label]="'PLEASE_WAIT' | translate"
                  [disabled]="true"
                ></app-button>
              }
            </div>
          }
        }
      </form>
    </div>
  </div>
</div>

<div>
  <app-service-progress
    [serviceName]="serviceType"
    [description]="subServiceType"
    [showProgress]="false"
  />
</div>
